module.exports = __webpack_public_path__ + "static/media/design d.c0b4805e.jpg";